import React from 'react';
import { Outlet } from 'react-router-dom';

import HeaderCheckout from 'components/organisms/HeaderCheckout';
import HelmetComponent from 'pages/HelmetComponent';

const CheckoutWebsiteLayout: React.FC = () => (
  <main className="website-layout">
    <HelmetComponent />
    <HeaderCheckout />
    <div className="website-layout_body">
      <Outlet />
    </div>
  </main>
);

export default CheckoutWebsiteLayout;
